// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file guest/v1/reservation.proto (package guest.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { ProductCancelPolicy } from "./product_pb";
import { file_guest_v1_product } from "./product_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guest/v1/reservation.proto.
 */
export const file_guest_v1_reservation: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_guest_v1_product]);

/**
 * @generated from message guest.v1.GetReservationContextRequest
 */
export type GetReservationContextRequest = Message<"guest.v1.GetReservationContextRequest"> & {
};

/**
 * Describes the message guest.v1.GetReservationContextRequest.
 * Use `create(GetReservationContextRequestSchema)` to create a new message.
 */
export const GetReservationContextRequestSchema: GenMessage<GetReservationContextRequest> = /*@__PURE__*/
  messageDesc(file_guest_v1_reservation, 0);

/**
 * @generated from message guest.v1.GetReservationContextResponse
 */
export type GetReservationContextResponse = Message<"guest.v1.GetReservationContextResponse"> & {
  /**
   * 案件アクセスの有効期限。本 RPC は x-case-token 必須のため常に設定される。
   * PoC 後にトークン任意の一般公開アクセスを導入した場合 (§6.2)、
   * caseToken なしのアクセスでは未設定になる。
   *
   * @generated from field: google.protobuf.Timestamp case_expires_at = 1;
   */
  caseExpiresAt?: Timestamp | undefined;

  /**
   * 案件のメール解析結果 (case_item.extracted_conditions) の予約希望日時。
   * AI が抽出できなかった場合は空文字 (ゲストが自分で選ぶ)。
   *
   * "2026-05-19" (JST)
   *
   * @generated from field: string preferred_date = 2;
   */
  preferredDate: string;

  /**
   * "19:00" (JST)
   *
   * @generated from field: string preferred_time = 3;
   */
  preferredTime: string;

  /**
   * 案件のメール解析結果 (case_item.extracted_conditions) の予約人数 (抽出値そのまま。例: "2名")。
   * AI が抽出できなかった場合は空文字。店舗画面の空席確認 (AvailabilityService.CheckAvailability)
   * の party_size 組み立てに使う (JPTP_CANSEI-1443)。
   *
   * @generated from field: string preferred_party_size = 4;
   */
  preferredPartySize: string;
};

/**
 * Describes the message guest.v1.GetReservationContextResponse.
 * Use `create(GetReservationContextResponseSchema)` to create a new message.
 */
export const GetReservationContextResponseSchema: GenMessage<GetReservationContextResponse> = /*@__PURE__*/
  messageDesc(file_guest_v1_reservation, 1);

/**
 * TicketOrder は予約枚数の入力 1 件。単価は含まない
 * (金額は Backend が read_model.product.prices から再計算する。§6.5)。
 *
 * @generated from message guest.v1.TicketOrder
 */
export type TicketOrder = Message<"guest.v1.TicketOrder"> & {
  /**
   * 価格種別キー (GetProductDetail の prices[].price_type)。
   *
   * @generated from field: string price_type = 1;
   */
  priceType: string;

  /**
   * 枚数。
   *
   * @generated from field: int32 quantity = 2;
   */
  quantity: number;
};

/**
 * Describes the message guest.v1.TicketOrder.
 * Use `create(TicketOrderSchema)` to create a new message.
 */
export const TicketOrderSchema: GenMessage<TicketOrder> = /*@__PURE__*/
  messageDesc(file_guest_v1_reservation, 2);

/**
 * ReservationTicket は予約に確定した枚数・金額の内訳 1 件
 * (read_model.reservation.tickets の要素構造。§5.2)。
 *
 * @generated from message guest.v1.ReservationTicket
 */
export type ReservationTicket = Message<"guest.v1.ReservationTicket"> & {
  /**
   * 価格種別キー (例: adult)。
   *
   * @generated from field: string price_type = 1;
   */
  priceType: string;

  /**
   * 表示名 (予約時点のスナップショット。例: 大人)。
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 単価 (JPY 最小通貨単位)。
   *
   * @generated from field: int64 unit_amount = 3;
   */
  unitAmount: bigint;

  /**
   * 枚数。
   *
   * @generated from field: int32 quantity = 4;
   */
  quantity: number;
};

/**
 * Describes the message guest.v1.ReservationTicket.
 * Use `create(ReservationTicketSchema)` to create a new message.
 */
export const ReservationTicketSchema: GenMessage<ReservationTicket> = /*@__PURE__*/
  messageDesc(file_guest_v1_reservation, 3);

/**
 * @generated from message guest.v1.RequestEmailVerificationRequest
 */
export type RequestEmailVerificationRequest = Message<"guest.v1.RequestEmailVerificationRequest"> & {
  /**
   * 認証対象のメールアドレス。認証後に変更された場合は再認証が必要 (§6.4)。
   *
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * 表示言語 (例: "ja")。認証コードメールの言語選択に使う (§8)。
   * 未指定・未対応の言語は英語 (en) にフォールバック。
   *
   * @generated from field: string language_code = 3;
   */
  languageCode: string;
};

/**
 * Describes the message guest.v1.RequestEmailVerificationRequest.
 * Use `create(RequestEmailVerificationRequestSchema)` to create a new message.
 */
export const RequestEmailVerificationRequestSchema: GenMessage<RequestEmailVerificationRequest> = /*@__PURE__*/
  messageDesc(file_guest_v1_reservation, 4);

/**
 * @generated from message guest.v1.RequestEmailVerificationResponse
 */
export type RequestEmailVerificationResponse = Message<"guest.v1.RequestEmailVerificationResponse"> & {
  /**
   * 発行した認証の ID。VerifyEmailCode で使う。
   *
   * @generated from field: string verification_id = 1;
   */
  verificationId: string;
};

/**
 * Describes the message guest.v1.RequestEmailVerificationResponse.
 * Use `create(RequestEmailVerificationResponseSchema)` to create a new message.
 */
export const RequestEmailVerificationResponseSchema: GenMessage<RequestEmailVerificationResponse> = /*@__PURE__*/
  messageDesc(file_guest_v1_reservation, 5);

/**
 * @generated from message guest.v1.VerifyEmailCodeRequest
 */
export type VerifyEmailCodeRequest = Message<"guest.v1.VerifyEmailCodeRequest"> & {
  /**
   * 認証 ID (RequestEmailVerification の応答)。
   *
   * @generated from field: string verification_id = 1;
   */
  verificationId: string;

  /**
   * ゲストが入力した 6 桁コード (例: "012345")。
   *
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message guest.v1.VerifyEmailCodeRequest.
 * Use `create(VerifyEmailCodeRequestSchema)` to create a new message.
 */
export const VerifyEmailCodeRequestSchema: GenMessage<VerifyEmailCodeRequest> = /*@__PURE__*/
  messageDesc(file_guest_v1_reservation, 6);

/**
 * @generated from message guest.v1.VerifyEmailCodeResponse
 */
export type VerifyEmailCodeResponse = Message<"guest.v1.VerifyEmailCodeResponse"> & {
};

/**
 * Describes the message guest.v1.VerifyEmailCodeResponse.
 * Use `create(VerifyEmailCodeResponseSchema)` to create a new message.
 */
export const VerifyEmailCodeResponseSchema: GenMessage<VerifyEmailCodeResponse> = /*@__PURE__*/
  messageDesc(file_guest_v1_reservation, 7);

/**
 * @generated from message guest.v1.CreateCheckoutSessionRequest
 */
export type CreateCheckoutSessionRequest = Message<"guest.v1.CreateCheckoutSessionRequest"> & {
  /**
   * 再決済の対象予約 ID (過去の CreateCheckoutSession の応答)。未指定なら予約を新規作成する。
   * 指定時は予約済みの内容 (shop_id 〜 language_code) で決済し、リクエストの同項目は使わない。
   * 決済待ち (pending_payment) なら旧セッションを expire してから再発行する (§7.2)。
   *
   * @generated from field: optional string reservation_id = 1;
   */
  reservationId?: string | undefined;

  /**
   * 予約者情報。email は認証済みであること (§6.4)。
   *
   * @generated from field: guest.v1.ReservationGuest guest = 2;
   */
  guest?: ReservationGuest | undefined;

  /**
   * 冪等化キー (クライアント採番。必須。予約 ID・集約バージョンと組み合わせて Stripe へも伝搬)。
   *
   * @generated from field: string idempotency_key = 3;
   */
  idempotencyKey: string;

  /**
   * JapanTicket shopId (新規作成時は必須)。
   *
   * @generated from field: int64 shop_id = 4;
   */
  shopId: bigint;

  /**
   * JapanTicket productId (新規作成時は必須)。
   *
   * @generated from field: int64 product_id = 5;
   */
  productId: bigint;

  /**
   * 利用日 (JST。例: "2026-05-19"。新規作成時は必須)。今日以降のみ許可。
   *
   * @generated from field: string visit_date = 6;
   */
  visitDate: string;

  /**
   * 利用時間 (JST。例: "19:00"。新規作成時は必須)。
   *
   * @generated from field: string visit_time = 7;
   */
  visitTime: string;

  /**
   * 枚数 (price type ごと。新規作成時は 1 件以上必須)。
   *
   * @generated from field: repeated guest.v1.TicketOrder tickets = 8;
   */
  tickets: TicketOrder[];

  /**
   * 表示言語 (例: "ja")。表示用スナップショット (shop_name / product_name /
   * tickets の表示名) の保存言語に使う。未指定・該当行なしは英語 (en) にフォールバック。
   *
   * @generated from field: string language_code = 9;
   */
  languageCode: string;
};

/**
 * Describes the message guest.v1.CreateCheckoutSessionRequest.
 * Use `create(CreateCheckoutSessionRequestSchema)` to create a new message.
 */
export const CreateCheckoutSessionRequestSchema: GenMessage<CreateCheckoutSessionRequest> = /*@__PURE__*/
  messageDesc(file_guest_v1_reservation, 8);

/**
 * ReservationGuest は予約者情報 (§6.5)。
 *
 * @generated from message guest.v1.ReservationGuest
 */
export type ReservationGuest = Message<"guest.v1.ReservationGuest"> & {
  /**
   * 姓。
   *
   * @generated from field: string last_name = 1;
   */
  lastName: string;

  /**
   * 名。
   *
   * @generated from field: string first_name = 2;
   */
  firstName: string;

  /**
   * 電話番号。
   *
   * @generated from field: string phone = 3;
   */
  phone: string;

  /**
   * メールアドレス (認証済みであること)。
   *
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * アレルギー (任意。自由記述)。
   *
   * @generated from field: string allergy = 5;
   */
  allergy: string;

  /**
   * 要望 (任意。自由記述)。
   *
   * @generated from field: string request = 6;
   */
  request: string;
};

/**
 * Describes the message guest.v1.ReservationGuest.
 * Use `create(ReservationGuestSchema)` to create a new message.
 */
export const ReservationGuestSchema: GenMessage<ReservationGuest> = /*@__PURE__*/
  messageDesc(file_guest_v1_reservation, 9);

/**
 * @generated from message guest.v1.CreateCheckoutSessionResponse
 */
export type CreateCheckoutSessionResponse = Message<"guest.v1.CreateCheckoutSessionResponse"> & {
  /**
   * Stripe Checkout の決済ページ URL。SPA はここへリダイレクトする。
   *
   * @generated from field: string checkout_url = 1;
   */
  checkoutUrl: string;

  /**
   * 決済対象の予約 ID (UUIDv7)。SPA は保持し、決済せずに戻ったときの再決済で
   * reservation_id に指定する (旧セッションを expire して二重決済を防ぐ。§7.2)。
   *
   * @generated from field: string reservation_id = 2;
   */
  reservationId: string;
};

/**
 * Describes the message guest.v1.CreateCheckoutSessionResponse.
 * Use `create(CreateCheckoutSessionResponseSchema)` to create a new message.
 */
export const CreateCheckoutSessionResponseSchema: GenMessage<CreateCheckoutSessionResponse> = /*@__PURE__*/
  messageDesc(file_guest_v1_reservation, 10);

/**
 * @generated from message guest.v1.GetReservationRequest
 */
export type GetReservationRequest = Message<"guest.v1.GetReservationRequest"> & {
};

/**
 * Describes the message guest.v1.GetReservationRequest.
 * Use `create(GetReservationRequestSchema)` to create a new message.
 */
export const GetReservationRequestSchema: GenMessage<GetReservationRequest> = /*@__PURE__*/
  messageDesc(file_guest_v1_reservation, 11);

/**
 * @generated from message guest.v1.GetReservationResponse
 */
export type GetReservationResponse = Message<"guest.v1.GetReservationResponse"> & {
  /**
   * 予約詳細 (x-reservation-token から解決)。
   *
   * @generated from field: guest.v1.Reservation reservation = 1;
   */
  reservation?: Reservation | undefined;
};

/**
 * Describes the message guest.v1.GetReservationResponse.
 * Use `create(GetReservationResponseSchema)` to create a new message.
 */
export const GetReservationResponseSchema: GenMessage<GetReservationResponse> = /*@__PURE__*/
  messageDesc(file_guest_v1_reservation, 12);

/**
 * Reservation はゲスト向けの予約詳細 (read_model.reservation 由来。§5.2)。
 * 予約完了画面・キャンセル画面の表示に必要な項目を返す。
 *
 * @generated from message guest.v1.Reservation
 */
export type Reservation = Message<"guest.v1.Reservation"> & {
  /**
   * 予約の状態 (§4.2)。
   *
   * @generated from field: guest.v1.ReservationStatus status = 1;
   */
  status: ReservationStatus;

  /**
   * ゲスト向け予約番号 (例: T-2026-000123。確定時に採番。未確定は空文字)。
   *
   * @generated from field: string reservation_number = 2;
   */
  reservationNumber: string;

  /**
   * 店舗名 (予約時点のスナップショット)。
   *
   * @generated from field: string shop_name = 3;
   */
  shopName: string;

  /**
   * 商品名 (予約時点のスナップショット)。
   *
   * @generated from field: string product_name = 4;
   */
  productName: string;

  /**
   * 利用日 (JST。例: "2026-05-19")。
   *
   * @generated from field: string visit_date = 5;
   */
  visitDate: string;

  /**
   * 利用時間 (JST。例: "19:00")。
   *
   * @generated from field: string visit_time = 6;
   */
  visitTime: string;

  /**
   * 枚数・金額の内訳。
   *
   * @generated from field: repeated guest.v1.ReservationTicket tickets = 7;
   */
  tickets: ReservationTicket[];

  /**
   * 合計金額 (JPY 最小通貨単位。確定後は支払い済み金額)。
   *
   * @generated from field: int64 total_amount = 8;
   */
  totalAmount: bigint;

  /**
   * 通貨コード (例: jpy)。
   *
   * @generated from field: string currency = 9;
   */
  currency: string;

  /**
   * 予約者の姓 (pending_payment 以降。未入力は空文字)。
   *
   * @generated from field: string guest_last_name = 10;
   */
  guestLastName: string;

  /**
   * 予約者の名 (pending_payment 以降。未入力は空文字)。
   *
   * @generated from field: string guest_first_name = 11;
   */
  guestFirstName: string;

  /**
   * 予約確定日時 (未確定は未設定)。
   *
   * @generated from field: google.protobuf.Timestamp confirmed_at = 12;
   */
  confirmedAt?: Timestamp | undefined;

  /**
   * 決済カードのブランド (例: visa。返金方法の表示用。未確定は空文字)。
   *
   * @generated from field: string card_brand = 13;
   */
  cardBrand: string;

  /**
   * 決済カードの末尾 4 桁 (返金方法の表示用。未確定は空文字)。
   *
   * @generated from field: string card_last4 = 14;
   */
  cardLast4: string;

  /**
   * キャンセル料 (JPY)。confirmed では現時点でキャンセルした場合の予定額 (§7.4)、
   * canceled 以降は実績値。算出対象外の状態では未設定。
   *
   * @generated from field: optional int64 cancel_fee = 15;
   */
  cancelFee?: bigint | undefined;

  /**
   * 返金額 (JPY)。confirmed では返金予定額、canceled 以降は実績値。
   * 算出対象外の状態では未設定。
   *
   * @generated from field: optional int64 refund_amount = 16;
   */
  refundAmount?: bigint | undefined;

  /**
   * 商品画像 URL (予約時点のスナップショット。read_model.reservation.product_image_url 由来。
   * キャンセル画面の商品画像表示用。未設定は空文字)。
   *
   * @generated from field: string product_image_url = 17;
   */
  productImageUrl: string;

  /**
   * キャンセルポリシー配列 (read_model.product.cancel_policy 由来。キャンセル画面のポリシー表示用)。
   *
   * @generated from field: repeated guest.v1.ProductCancelPolicy cancel_policies = 18;
   */
  cancelPolicies: ProductCancelPolicy[];
};

/**
 * Describes the message guest.v1.Reservation.
 * Use `create(ReservationSchema)` to create a new message.
 */
export const ReservationSchema: GenMessage<Reservation> = /*@__PURE__*/
  messageDesc(file_guest_v1_reservation, 13);

/**
 * @generated from message guest.v1.CancelReservationRequest
 */
export type CancelReservationRequest = Message<"guest.v1.CancelReservationRequest"> & {
  /**
   * キャンセル理由 (選択式。必須)。
   *
   * @generated from field: guest.v1.CancelReasonCode reason_code = 1;
   */
  reasonCode: CancelReasonCode;

  /**
   * キャンセル理由の自由記述 (任意)。
   *
   * @generated from field: string reason_note = 2;
   */
  reasonNote: string;

  /**
   * 冪等化キー (クライアント採番。必須。Stripe Refund へも伝搬)。
   *
   * @generated from field: string idempotency_key = 3;
   */
  idempotencyKey: string;

  /**
   * 画面表示時の返金予定額 (GetReservation の refund_amount のエコーバック。必須)。
   * 実行時の再算出値と異なる場合 (日付またぎ等。§3.2) は FailedPrecondition を返し、
   * SPA は GetReservation を再取得して画面を再表示する。
   *
   * @generated from field: int64 expected_refund_amount = 4;
   */
  expectedRefundAmount: bigint;

  /**
   * キャンセル完了メールの言語 (例: "ja")。未指定・未対応は英語 (en) にフォールバック (§8)。
   *
   * @generated from field: string language_code = 5;
   */
  languageCode: string;
};

/**
 * Describes the message guest.v1.CancelReservationRequest.
 * Use `create(CancelReservationRequestSchema)` to create a new message.
 */
export const CancelReservationRequestSchema: GenMessage<CancelReservationRequest> = /*@__PURE__*/
  messageDesc(file_guest_v1_reservation, 14);

/**
 * @generated from message guest.v1.CancelReservationResponse
 */
export type CancelReservationResponse = Message<"guest.v1.CancelReservationResponse"> & {
  /**
   * キャンセル料 (JPY。実行時点の算出値。§7.4)。
   *
   * @generated from field: int64 cancel_fee = 1;
   */
  cancelFee: bigint;

  /**
   * 返金額 (JPY。0 の場合は返金なし)。
   *
   * @generated from field: int64 refund_amount = 2;
   */
  refundAmount: bigint;
};

/**
 * Describes the message guest.v1.CancelReservationResponse.
 * Use `create(CancelReservationResponseSchema)` to create a new message.
 */
export const CancelReservationResponseSchema: GenMessage<CancelReservationResponse> = /*@__PURE__*/
  messageDesc(file_guest_v1_reservation, 15);

/**
 * ReservationStatus は予約の状態 (§4.2 の状態遷移に対応)。
 *
 * @generated from enum guest.v1.ReservationStatus
 */
export enum ReservationStatus {
  /**
   * @generated from enum value: RESERVATION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 仮予約 (廃止。JPTP_CANSEI-1678 以前に作成された旧データのみ)。
   *
   * @generated from enum value: RESERVATION_STATUS_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * Checkout Session 発行済み。決済待ち。
   *
   * @generated from enum value: RESERVATION_STATUS_PENDING_PAYMENT = 2;
   */
  PENDING_PAYMENT = 2,

  /**
   * 決済完了 + 外部予約確定 = 予約確定。
   *
   * @generated from enum value: RESERVATION_STATUS_CONFIRMED = 3;
   */
  CONFIRMED = 3,

  /**
   * 決済は完了したが外部予約確定に失敗。全額返金の補償処理へ (§7.7)。
   *
   * @generated from enum value: RESERVATION_STATUS_FINALIZE_FAILED = 4;
   */
  FINALIZE_FAILED = 4,

  /**
   * キャンセル済み (返金額 0 はここが終端)。
   *
   * @generated from enum value: RESERVATION_STATUS_CANCELED = 5;
   */
  CANCELED = 5,

  /**
   * 返金完了 (終端)。
   *
   * @generated from enum value: RESERVATION_STATUS_REFUNDED = 6;
   */
  REFUNDED = 6,

  /**
   * 返金失敗。運用で手動対応。
   *
   * @generated from enum value: RESERVATION_STATUS_REFUND_FAILED = 7;
   */
  REFUND_FAILED = 7,

  /**
   * 来店済み (終端)。来店確定バッチが遷移させる。
   *
   * @generated from enum value: RESERVATION_STATUS_VISITED = 8;
   */
  VISITED = 8,

  /**
   * 決済期限切れ。Checkout Session の離脱・期限切れで決済待ちから戻った状態。
   * 予約者情報を保持し、再決済で決済待ちへ戻れる (JPTP_CANSEI-1678)。
   *
   * @generated from enum value: RESERVATION_STATUS_CHECKOUT_EXPIRED = 9;
   */
  CHECKOUT_EXPIRED = 9,
}

/**
 * Describes the enum guest.v1.ReservationStatus.
 */
export const ReservationStatusSchema: GenEnum<ReservationStatus> = /*@__PURE__*/
  enumDesc(file_guest_v1_reservation, 0);

/**
 * CancelReasonCode はキャンセル理由 (§6.6。モックの選択肢に対応)。
 *
 * @generated from enum guest.v1.CancelReasonCode
 */
export enum CancelReasonCode {
  /**
   * @generated from enum value: CANCEL_REASON_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * ご都合により参加できなくなった。
   *
   * @generated from enum value: CANCEL_REASON_CODE_CANNOT_ATTEND = 1;
   */
  CANNOT_ATTEND = 1,

  /**
   * 別の体験を予約したい。
   *
   * @generated from enum value: CANCEL_REASON_CODE_BOOK_OTHER = 2;
   */
  BOOK_OTHER = 2,

  /**
   * 価格・キャンセル料について。
   *
   * @generated from enum value: CANCEL_REASON_CODE_PRICE_OR_FEE = 3;
   */
  PRICE_OR_FEE = 3,

  /**
   * 体験内容が想定と違った。
   *
   * @generated from enum value: CANCEL_REASON_CODE_NOT_AS_EXPECTED = 4;
   */
  NOT_AS_EXPECTED = 4,

  /**
   * その他。
   *
   * @generated from enum value: CANCEL_REASON_CODE_OTHER = 5;
   */
  OTHER = 5,
}

/**
 * Describes the enum guest.v1.CancelReasonCode.
 */
export const CancelReasonCodeSchema: GenEnum<CancelReasonCode> = /*@__PURE__*/
  enumDesc(file_guest_v1_reservation, 1);

/**
 * ReservationService はゲスト向けの予約・決済フローを提供する
 * (ゲスト予約・決済_詳細設計 §6)。予約の確定は Stripe Checkout の決済完了
 * Webhook が担うため、CommitReservation に相当する RPC は存在しない (§6.1)。
 *
 * 認可はトークンの系統で 2 つに分かれる (§6.5):
 *   - 案件フロー内の RPC (GetReservationContext / RequestEmailVerification /
 *     VerifyEmailCode / CreateCheckoutSession) は
 *     既存の Guest 公開 Interceptor (x-case-token) を通り、案件スコープに閉じる。
 *   - 予約系画面の RPC (GetReservation / CancelReservation) は予約アクセストークン
 *     (x-reservation-token) で認可する。Interceptor がトークンを検証・復号して
 *     reservation_id・tenant_id を ctx に注入するため、リクエストに
 *     reservation_id パラメータは持たない。
 *
 * @generated from service guest.v1.ReservationService
 */
export const ReservationService: GenService<{
  /**
   * GetReservationContext は商品詳細画面の予約フォーム表示に必要な
   * 予約コンテキストを返す (§6.2)。案件の有効性確認を兼ね、利用日・時間の
   * 初期値 (案件のメール解析結果の予約希望日時) を返す。
   * 価格表・枚数上限は GetProductDetail の応答に含まれるため本 RPC では返さない。
   * 応答はすべて x-case-token で解決した案件由来のため、リクエストにパラメータは持たない
   * (提案範囲内検証は同画面で呼ぶ GetProductDetail と、決済時の CreateCheckoutSession が担う)。
   *
   * @generated from rpc guest.v1.ReservationService.GetReservationContext
   */
  getReservationContext: {
    methodKind: "unary";
    input: typeof GetReservationContextRequestSchema;
    output: typeof GetReservationContextResponseSchema;
  },
  /**
   * RequestEmailVerification はメールアドレス認証の 6 桁コードを発行し、
   * 対象メールアドレスへ送信する (§6.4)。認証は x-case-token で解決した案件に紐付き、
   * 予約 ID を必要としない (JPTP_CANSEI-1678)。コードは発行から 5 分で失効する。
   * 同一案件への再送は 60 秒間抑止する (§5.1)。
   *
   * @generated from rpc guest.v1.ReservationService.RequestEmailVerification
   */
  requestEmailVerification: {
    methodKind: "unary";
    input: typeof RequestEmailVerificationRequestSchema;
    output: typeof RequestEmailVerificationResponseSchema;
  },
  /**
   * VerifyEmailCode は 6 桁コードを照合する (§6.4)。試行は 5 回までで、
   * 超過すると当該コードは無効化され再発行が必要になる。
   * 期限切れ (5 分) は FailedPrecondition を返す。
   *
   * @generated from rpc guest.v1.ReservationService.VerifyEmailCode
   */
  verifyEmailCode: {
    methodKind: "unary";
    input: typeof VerifyEmailCodeRequestSchema;
    output: typeof VerifyEmailCodeResponseSchema;
  },
  /**
   * CreateCheckoutSession は予約を作成 (reservation_id 未指定時) または再決済
   * (reservation_id 指定時) し、Stripe Checkout の決済 URL を発行する (§6.5)。
   * 新規作成では提案範囲内・visit_date >= 今日 (JST)・枚数上限を検証し、金額は
   * read_model.product.prices から再計算する (単価はクライアントから受け取らない)。
   * 「案件 × guest.email」のメール認証済みを検証し、TableCheck 空席確認を経て
   * Checkout Session を作成する。空席なしは ResourceExhausted (日時変更を促す)。
   * idempotency_key は予約の新規作成の冪等化に使い、Stripe の Idempotency-Key の組み立てにも使う。
   *
   * @generated from rpc guest.v1.ReservationService.CreateCheckoutSession
   */
  createCheckoutSession: {
    methodKind: "unary";
    input: typeof CreateCheckoutSessionRequestSchema;
    output: typeof CreateCheckoutSessionResponseSchema;
  },
  /**
   * GetReservation は x-reservation-token から解決した予約の詳細を返す (§6.5)。
   * 予約完了画面は本 RPC のポーリングで決済完了 (confirmed) を待つ (§3.1)。
   * キャンセル画面向けに、確定済み予約では返金予定額・キャンセル料・
   * カード brand / 末尾 4 桁を含めて返す (§3.2)。
   *
   * @generated from rpc guest.v1.ReservationService.GetReservation
   */
  getReservation: {
    methodKind: "unary";
    input: typeof GetReservationRequestSchema;
    output: typeof GetReservationResponseSchema;
  },
  /**
   * CancelReservation は x-reservation-token から解決した予約をキャンセルし、
   * キャンセルポリシー (§7.4) に基づく返金を行う (§6.6)。
   * 状態が confirmed、かつ現在時刻 (JST) が来店日 23:59 以前の場合のみ可能。
   * 画面表示時と実行時で返金額が変わった場合は実行時点の額を正とし、
   * エラーを返して画面を再表示させる (§3.2)。idempotency_key は Refund へも伝搬する。
   *
   * @generated from rpc guest.v1.ReservationService.CancelReservation
   */
  cancelReservation: {
    methodKind: "unary";
    input: typeof CancelReservationRequestSchema;
    output: typeof CancelReservationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guest_v1_reservation, 0);

